/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { City } from './city.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as CitiesActions from './city.actions';
import { Action, createReducer, on } from '@ngrx/store';

export interface CitiesState extends EntityState<City> {
  loading: boolean;
}

export const adapter: EntityAdapter<City> = createEntityAdapter<City>({
  selectId: city => city.guid,
});

const initialCitiesState: CitiesState = adapter.getInitialState({
  loading: false,
});

const reducer = createReducer(
  initialCitiesState,
  on(CitiesActions.AllCitiesRequested, (state: CitiesState, action) => ({
      ...state,
      loading: true,
    })),
  on(CitiesActions.AllCitiesLoaded, (state: CitiesState, action) => adapter.setAll(action.cities, { ...state, loading: false })),
  on(CitiesActions.AllCitiesFailed, (state: CitiesState, action) => ({
      ...state,
      loading: false,
    })),
);

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

export function cityReducers(state: CitiesState, action: Action) {
  return reducer(state, action);
}
